export default __webpack_public_path__ + "static/media/Helm of the Fallen Empire.6fc305e2.jpg";